<template>
    <v-app id="inspire">
        <v-card class="mx-auto" max-width="100%">
            <v-container>
                <v-row dense>
                    <v-col cols="12">
                        <v-card color="#385F73" dark>
                            <v-card-title class="headline">
                                Misión:
                            </v-card-title>

                            <v-card-text>
                                <p>
                                    * Planificar las auditorías, elaborar listados de chequeo y aprobarlos.
                                </p>
                                <p>
                                    * Realizar las auditorías exhaustivas a las distintas áreas de la empresa.
                                </p>
                                <p>
                                    * Informar si el SGI es efectivo para alcanzar los objetivos prescriptos,
                                    proporcionando evidencias objetivas sobre el funcionamiento del sistema, para su
                                    evaluación y adopción de medidas correctivas.
                                </p>

                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-app>
</template>

<script>
// import router from "../src/router/index";
// import axios from "../src/axios-auth.js";
import moment from "moment";

export default {
    data: () => ({
        usuario: null,
        now: moment(),
        diferencia: "",
    }),
    watch: {},
    created() {
        this.usuario = this.$store.state.usuario.toString().trim();
    },
    mounted() {
        if (this.$store.state.usuario == "" || this.$store.state.usuario == null) {
            this.$store.dispatch("logout");
        } else {
            this.$store.state.sector = "Auditoria";
            //  this.cargaraccidentes();
        }
    },
    methods: {},
};
</script>